'use strict';

import { Router } from '@angular/router';
import { $locationShim } from '@angular/common/upgrade';
import { downgradeInjectable } from '@angular/upgrade/static';
import angular from 'angular';
import { AJS_MODULE_NAME } from '@common/constants';
import {
	AjsNgxModalService,
	ApiVersionService,
	AuthService,
	FlyoutService,
	LoadingService,
	NavigationService,
	ReportService,
	SocketService,
} from '@app/core/services';
import { AbsenceService } from '@app/shared/services/absence.service';
import { PurchaseOrderSetupService } from '@app/modules/system-settings/system-setup/purchase-order-setup/services/purchase-order-setup.service';
import { LocalUseService } from '@app/shared/components/local-use-data-entry/services/local-use.service';
import { PopoverService } from '@app/shared/components/popover/popover.service';
import { DocManagementService } from '@app/shared/components/doc-management/services/doc-management.service';

angular
	.module(AJS_MODULE_NAME)
	.factory('authService', downgradeInjectable(AuthService)) // replace ajs authService with ngx AuthService
	.factory('ajsNgxModalService', downgradeInjectable(AjsNgxModalService))
	.factory('$location', downgradeInjectable($locationShim))
	.factory('socketService', downgradeInjectable(SocketService))
	.factory('absenceService', downgradeInjectable(AbsenceService))
	.factory('apiVersionService', downgradeInjectable(ApiVersionService))
	.factory('localUseService', downgradeInjectable(LocalUseService))
	.factory('navigationService', downgradeInjectable(NavigationService))
	.factory('popoverService', downgradeInjectable(PopoverService))
	.factory('purchaseOrderSetupService', downgradeInjectable(PurchaseOrderSetupService))
	.factory('reportHelper', downgradeInjectable(ReportService))
	.factory('ngxRouter', downgradeInjectable(Router))
	.factory('flyoutService', downgradeInjectable(FlyoutService))
	.factory('documentService', downgradeInjectable(DocManagementService))
	.factory('loadingService', downgradeInjectable(LoadingService));
